import React, { Component } from "react";
import DocumentList from "../../Common/DocumentList";
import ApprovalInformation from "../../Common/ApprovalInformation";
import { main_url, getBranch, fno } from "../../../utils/CommonFunction";
import Select from "react-select";
import EamPaymentApprovalInformation from "../../Common/EamPaymentApprovalInformation";
import { getHeaders } from "../../../utils/apiHelper";

class FuneralBenefitView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      datasource: props.data.data[0],
      detail: props.data.detail,
      doc: props.data.doc,
      status_info: [],
      document: [],
      selected_location: [], //Added by STHA
      branch: [], //Added by STHA
      eamPaymentDetailsInfo: [],
    };
  }

  getAvailableAmount() {
    fetch(`${main_url}funeral_benefit/getFuneralAvailableAmount`, {
      headers: getHeaders(),
    })
      .then((res) => {
        if (res.ok) return res.json();
      })
      .then((list) => {
        this.setState({
          available_amount: list.amount,
        });
      });
  }

  componentDidMount() {
    this.getStatusInfo();
    this.getAvailableAmount();
    this.getAllBranches(); // Added by STHA
    this.getEamPaymentInfo();
  }

  //Added by STHA to get EAM Payment Info
  getEamPaymentInfo() {
    let form_no = this.state.datasource.form_no; // Form Number
    let type = "Funeral";
    fetch(`${main_url}eam_payment/getEamPaymentInfo/${form_no}/${type}`, {
      headers: getHeaders(),
    })
      .then((res) => res.json())
      .then((res) => {
        this.setState({
          eamPaymentDetailsInfo: res,
        });
      })
      .catch((error) => console.log(error));
  }

  //Added by STHA
  async getAllBranches() {
    let branch = await getBranch();
    let selected_location = this.getSelectedLocation(
      branch,
      this.state.datasource.withdraw_location
    );
    this.setState({
      branch: branch,
      selected_location: selected_location,
    });
  }

  //Added by STHA
  getSelectedLocation(branch, location) {
    let selected = branch.filter(function (b) {
      return b.value === location;
    });
    return selected;
  }

  getStatusInfo() {
    fetch(
      `${main_url}funeral_benefit/getOneDetailInfo/${this.state.datasource.funeral_benefit_id}`, {
        headers: getHeaders(),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        this.setState({
          status_info: res,
        });
      })
      .catch((error) => console.log(error));
  }

  getTotalAmount(amount) {
    let arr = this.state.detail;

    let tot = 0;
    for (let i = 0; i < arr.length; i++) {
      tot += amount / arr[i].headNo;
    }
    return tot;
  }

  render() {
    return (
      <div className="benefits benefit-funeral-add-new">
        <div className="row">
          <div className="form-group">
            <div className="row">
              <div className="col-md-12">
                <div>
                  <label htmlFor="employee-name" className="col-sm-12">
                    Voucher No.
                  </label>
                </div>
                <div className="col-sm-11">
                  <input
                    disabled
                    type="text"
                    className="form-control"
                    value={fno.fno_funeral + this.state.datasource.form_no}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div>
                  <label htmlFor="employee-name" className="col-sm-12">
                    Employee Name
                  </label>
                </div>
                <div className="col-sm-10">
                  <input
                    disabled
                    type="text"
                    className="form-control"
                    value={this.state.datasource.fullname}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div>
                  <label htmlFor="designation" className="col-sm-12">
                    Designation
                  </label>
                </div>
                <div className="col-sm-10">
                  <input
                    type="text"
                    // placeholder="Please Provide The Designation"
                    className="form-control"
                    disabled
                    // onChange={this.handleDesignation.bind(this)}
                    value={this.state.datasource.designations}
                  />
                </div>
              </div>
            </div>

            <div className="row">
              {/* <div className="ownspacing"></div> */}
              <div className="col-md-10 funeral-detail">
                <h4>Benefit Funeral Person</h4>
              </div>
              <div className="col-md-10 funeral-detail">
                <table className="table table-bordered table-responsive">
                  <thead>
                    <tr>
                      <th>Person Type</th>

                      <th>Head No</th>
                    </tr>
                  </thead>

                  <tbody>
                    {this.state.detail.length <= 0 ? (
                      <td colSpan="3" class="text-center">
                        No data
                      </td>
                    ) : (
                      this.state.detail.map((data, index) => {
                        return (
                          <tr key={index}>
                            <td>{data.selected_personName}</td>

                            <td>{data.headNo}</td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div>
                  <label className="col-sm-12">Available Amount</label>
                </div>
                <div className="col-sm-10">
                  <input
                    type="text"
                    className="form-control"
                    disabled
                    value={this.getTotalAmount(
                      this.state.datasource.total_amount
                    )}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div>
                  <label className="col-sm-12">Total Amount</label>
                </div>
                <div className="col-sm-10">
                  <input
                    type="text"
                    className="form-control"
                    disabled
                    value={this.state.datasource.total_amount}
                  />
                </div>
              </div>
            </div>

            {/* Added by STHA  */}
            <div className="row">
              <div className="col-md-6">
                <div>
                  <label className="col-sm-12">Withdrawal Location</label>
                </div>
                <div className="col-sm-10">
                  <Select
                    data-name="withdraw_location"
                    value={this.state.selected_location}
                    isDisabled={true}
                    // onChange={this.changeWithdrawLocation}
                    // options={this.state.branch}
                    className="react-select-container checkValidate"
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
            </div>
            {/* Added end by STHA  */}
          </div>
          <div className="row document-main">
            {this.state.doc.length > 0 ? (
              <DocumentList
                title="Funeral Benefit Document"
                doc={this.state.doc}
                path="funeral_benefit"
              />
            ) : (
              ""
            )}
          </div>
          {!Array.isArray(this.state.status_info) ? (
            <div className="row approval-main margin-top-20">
              <ApprovalInformation status={this.state.status_info} />
              {this.state.eamPaymentDetailsInfo &&
                this.state.eamPaymentDetailsInfo.length > 0 && (
                  <EamPaymentApprovalInformation
                    eamPaymentDetailsInfo={this.state.eamPaymentDetailsInfo}
                  />
                )}
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}
export default FuneralBenefitView;
